<template>
    <div class="pag">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <!-- <b-icon
                        pack="far"
                        icon="comment-dots"
                        size="is-small"
                        id="header-icon">
                    </b-icon> -->
                    
                    <h1 class="title">SMS</h1>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-button
                        type="is-primary"
                        icon-left="users"
                        style="font-size: 14px"
                        size="is-medium"
                        @click="openModal = true">
                        Clientes Alcançados
                    </b-button>
                </div>
            </div>
        </div>

        <section>
            <div id="containerMessage" >
                <b-field label="Mensagem" style="margin-bottom: 5px; text-align: left">
                    <b-input
                    type="textarea"
                    v-model="sms.message"
                    :maxlength="maxLength"
                    :has-counter="false">
                    
                    </b-input>
                </b-field>

                <div class="level">
                    <div class="level-left">
                        <b-field>
                            <b-switch v-model="sms.isEnabled" type="is-info" size="is-small">
                                Envio ativo
                            </b-switch>
                        </b-field>
                    </div>

                    <div class="level-right">
                        <p style="font-size: 12px">
                            {{smsLength}}/{{maxLength}}
                        </p>
                    </div>
                </div>
                
            </div>

            <div >
                <div class="level-right">
                    <b-button type="is-info" :disabled="!formValid" @click="saveSms()">Salvar</b-button>
                </div>
            </div>
        </section>

        <div id="textExplication" style="font-size: 14px; color: rgb(147, 147, 147); text-align: left; margin-top: 10px">
            <p v-html="example"></p>
        </div>

        <b-modal :active.sync="openModal">
            <table-sms :smsID="sms.id"></table-sms>
        </b-modal>
    </div>
</template>

<script>
    import Webservices from "@/Webservices";
    import { mapGetters, mapActions } from "vuex";
    import tableSms from "@/components/custom/tableSms";

    const ws = new Webservices();

    export default {
        components: {
            tableSms
        },
        data(){
            return {
                sms: {
                    campaignID: 0,
                    clientID: "",
                    name: "bem-vindo",
                    message: "",
                    isEnabled: false,
                    category: "transactional",
                    counter: 0
                },
                maxLength: 160,
                smsLength: 0,
                formValid: false,
                openModal: false,
                editSms: false,
                example: `Para utilizar o nome do cliente que receberá o SMS, utilize o texto
                    {{nome}}. Por exemplo: &quotObrigado por sua visita, {{nome}}!&quot será
                    enviado como: &quotObrigado por sua visita, Mário!&quot;`
            }
        }, mounted(){
            if (this.sms.message != ''){
                this.formValid = true;
            } else {
                this.formValid = false;
            }

            this.getClientData();
        },
        computed: {
            ...mapGetters(["getID"]),
        },
        watch: {
            getID() {
                this.sms = {
                campaignID: 0,
                clientID: "",
                name: "",
                message: "",
                isEnabled: false,
                category: "transactional"
                };
                
                this.getClientData();
            },
            "sms.message": function(v) {
               if (v != undefined){
                    this.smsLength = v.length;

                    if (this.smsLength > 0){
                        this.formValid = true;
                    } else {
                        this.formValid = false;
                    }
                }
            }
        }, methods: {
            getClientData(){
                ws.getSms(this.getID).then(
                    response => {
                    if (response.data.length != 0){
                        this.sms = response.data[0];
                        this.editSms = true;
                    } else {
                        this.editSms = false;
                    }
                })
            },

            saveSms(){
                this.sms.clientID = this.getID;
                if (!this.editSms){
                    ws.postSms(this.sms)
                    .then(
                        () => {
                            alert("SMS cadastrada com sucesso.")
                    })
                    .catch(
                        () => {
                            alert("Ocorreu um erro ao cadastrar a SMS.")
                        })
                } else {
                    ws.putSms(this.sms.id, this.sms)
                    .then(
                        () => {
                        alert("SMS cadastrada com sucesso.")
                    })
                    .catch(
                        () => {
                            alert("Ocorreu um erro ao cadastrar a SMS.")
                        })
                }
            }
        }
    }
</script>

<style>
    .pag {
        padding: 50px;
    };

    #containerMessage {
        text-align: start;
        padding: 0px;
        margin-bottom: 5px;
        align-content: start;
    };

    #header-icon {
        margin-right: 5px;
    };

    .button-section {
        margin-bottom: 10px;
    };
</style>


// WEBPACK FOOTER //
// src/components/smsNv.vue